import { useRef } from 'react';
import { BaseOption, BasicFilterSelect } from 'ui/selects';
import styled from 'styled-components';
import { isString } from 'utils/tsHelpers';
import { useClickAway } from 'react-use';
import { useMergeTagsContext } from '../contexts/mergeTags';
import { useTranslation } from '../../../../../hooks/useTranslation';

const StyledBasicFilterSelect = styled(BasicFilterSelect)`
  #trigger-merge-tag-select {
    border: none;
    box-shadow: none;
  }
`;

type MergeTagsMenuProps = {
  onSelect: (fieldName: string) => void;
  onClose: () => void;
};

export const MergeTagsMenu = ({ onSelect, onClose }: MergeTagsMenuProps) => {
  const { mergeTags, isLoading } = useMergeTagsContext();
  const { t } = useTranslation();
  const portalElementRef = useRef<HTMLDivElement | null>(null);
  useClickAway(portalElementRef, onClose);

  const options: BaseOption[] = mergeTags.map((mergeTag) => ({
    id: `${mergeTag.type}:${mergeTag.fieldName}`,
    label: mergeTag.fieldName,
    value: mergeTag.fieldName,
    Suffix: mergeTag.type,
  }));

  const placeholder = t(
    isLoading
      ? 'contentPicker.textEditor.loadingMergeTags'
      : 'contentPicker.textEditor.noMergeTags',
  );

  return (
    <StyledBasicFilterSelect
      id="merge-tag-select"
      options={options}
      emptyStateText={placeholder}
      Trigger={() => null}
      suffixUsed
      autoFocusOnInput
      isLoading={isLoading}
      width="400px"
      onSelect={([fieldName]) => (isString(fieldName) ? onSelect(fieldName) : null)}
      defaultValue={undefined}
      shouldOpenOnDefault
      allowClickOutsideToClose={false}
      portalElementRef={portalElementRef}
    />
  );
};
